module.exports = __webpack_public_path__ + "img/6.04b8aa25.png";